<template>
  <div class="pages_pickers_container">
    <slot />
    <div class="separator"></div>
    <div class="pickerLabel">{{ $t("general.selectPage") }}:</div>
    <div class="page_picker_container_book">
      <PagesPicker @pageselect="setPage" :tabId="tabId"></PagesPicker>
    </div>
  </div>
</template>

<script>
import PagesPicker from "./PagesPicker.vue";
import { openBook, goToPage } from "@/services/bookData";
import { mapGetters } from "vuex";
export default {
  computed: {
    book() {
      return this.$store.state.tabs[this.tabId].book;
    },
  },
  components: {
    PagesPicker,
  },
  props: ["tabId"],
  methods: {
    setPage(v) {
      goToPage(v.number, this.tabId);
    },
  },
};
</script>

<style scoped>
.pickerLabel {
  padding-right: 8px;
  width: 38px;
  padding-left: 5px;
  margin-top: -3px;
}
.pages_pickers_container {
  width: 115px;
  top: 2px;
  left: 0px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
}
.page_picker_container_book {
  border-style: solid;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d4d4d4;
  border-radius: 16px;
  border-width: 1px;
  height: 30px;

  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: visible;
  cursor: pointer;
  height: 26px;
  box-sizing: border-box;
  margin-bottom: 2px;
}
.separator {
  border-right: solid 1px rgba(0, 0, 0, 0.15);
  margin-right: 5px;
  width: 1px;
  height: 70%;
  margin-bottom: 8px;
  margin-top: 11px;
}
</style>
